import { LoginService } from 'app/services/login/login.service';
import { Component } from '@angular/core';

@Component({
  selector: 'app-letra',
  templateUrl: './letra.component.html',
  styleUrls: ['./letra.component.scss']
})
export class LetraComponent  {


  constructor(private loginService:LoginService) { }

  

  clickGuard(){
    this.loginService.clickGuard = true;
 }


}
